import AbstractHttpService from '@services/abstractHttpService';

import urls from '@const/urls';

import { AxiosResponse } from 'axios';
import {
  IGetDocumentFileArgs,
  IGetDocumentPreviewArgs
} from '@services/types';
import { Nullable } from '@app/types';

export interface ISharedCompleteTaskRequest {
  comment?: Nullable<string>;
  signer?: {
    fullName: string;
    initials: Nullable<string>;
    position: Nullable<string>;
  };
}

class SharedService extends AbstractHttpService {
  private readonly url = urls.shared

  async getDocumentFile ({ sharedLinkOguid, fileIndex, fileType }: IGetDocumentFileArgs): Promise<AxiosResponse<ArrayBuffer>> {
    const url = this.url.getDocumentFile
      .replace('{{ sharedLinkOguid }}', sharedLinkOguid)
      .replace('{{ fileIndex }}', fileIndex)
      .replace('{{ fileType }}', fileType)

    return await this._http.get(url, { responseType: 'arraybuffer' })
  }

  async getSharedOguid (envelopeOguid: string): Promise<AxiosResponse<string>> {
    const url = this.url.generateShare
      .replace('{{ envelopeOguid }}', envelopeOguid)

    return await this._http.post(url, {})
  }

  async postCompleteTask (
    sharedLinkOguid: string,
    data: ISharedCompleteTaskRequest
  ): Promise<AxiosResponse> {
    const url = this.url.completeTask
      .replace('{{ sharedLinkOguid }}', sharedLinkOguid)

    return await this._http.post(url, data)
  }

  async getPreviewFile ({ sharedLinkOguid, fileIndex, page }: IGetDocumentPreviewArgs): Promise<AxiosResponse<string>> {
    const url = this.url.getDocumentReview
      .replace('{{ sharedLinkOguid }}', sharedLinkOguid)
      .replace('{{ fileIndex }}', fileIndex)
      .replace('{{ page }}', page)

    return await this._http.get(url, {responseType: 'blob'})
  }
}

export default new SharedService()
